module.exports = __webpack_public_path__ + "img/instagram.923f804b.svg";